module.exports = __webpack_public_path__ + "static/media/rating_filter.58c1adee.svg";